<template>
  <div :class="$style.formFieldWrap" v-bind="$attrs">
    <slot />
  </div>
</template>

<style module>
.formFieldWrap {
  width: 100%;
  position: relative;

  *+& {
    margin-top: var(--space-xs);
  }
}
</style>
